module.exports = __webpack_public_path__ + "static/media/game-console-handheld.f1dc9217.svg";